module.exports = __webpack_public_path__ + "img/desktop_cover_a.d44f7497.png";